
import { PropTypes } from 'prop-types';
const Location = ({campusData}) => {
    const howToGetHereAddress = campusData?.howToGetHereAddress
    const howToGetHerePhoneNumber = campusData?.howToGetHerePhoneNumber
    const howToGetHereURL = campusData?.howToGetHereURL
    return (
        <div className="flex flex-col items-center justify-center gap-4 mt-8">
            <div className="flex flex-col items-center gap-3">
                <h2 className="text-center text-black text-3xl font-semibold ">How to get here?</h2>
                <div className="text-center flex gap-2 flex-col">
                    <span className="text-zinc-950 text-xl font-normal  w-auto max-w-[70ch] ">{howToGetHereAddress}</span>
                    <span className="text-zinc-950 text-2xl font-semibold ">T: {howToGetHerePhoneNumber}</span>
                </div>
                <div className="flex w-full items-center justify-center  mt-5">
                    <iframe className="lg:max-w-7xl w-full rounded-xl overflow-hidden border shadow" height={600} src={howToGetHereURL}  style={{border:0}} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                    

                </div>
            </div>
        </div>
    )
}
Location.propTypes = {
    campusData: PropTypes.object
}
export default Location